import { render } from "./HomeReviews.vue?vue&type=template&id=345d56a6&scoped=true&ts=true"
import script from "./HomeReviews.vue?vue&type=script&lang=ts"
export * from "./HomeReviews.vue?vue&type=script&lang=ts"

import "./HomeReviews.vue?vue&type=style&index=0&id=345d56a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345d56a6"]])

export default __exports__